import styled from "styled-components";

export const ButtonContainerStyled = styled.div`
  margin-top: auto;
  margin-bottom: 0;
  margin-left: auto;
`;